export const ROUTE_DASHBOARD = '/dashboard';

// Auth
export const ROUTE_REGISTER = (id = ":id") => `/auth/register/${id}`;
export const ROUTE_LOGIN = '/auth/login';
export const ROUTE_FORGOT_PASSWORD = '/auth/forgot-password';
export const ROUTE_RESET_PASSWORD = '/auth/reset-password/:id';

// Profile
export const ROUTE_PROFILE_EDIT = '/edit-profile';

// Users
export const ROUTE_USERS_LIST = '/users';

// Workspaces
export const ROUTE_WORKSPACES_LIST = '/workspaces';
export const ROUTE_ACTIVE_WORKSPACES_DETAILS = '/active-workspace-details';
export const ROUTE_WORKSPACE_CREATE = "/workspaces/create";
export const ROUTE_WORKSPACE_BLOCKED = "/workspaces/blocked";

// Workspace details
export const ROUTE_WORKSPACE_DETAIL = (id = ":id") => `/workspace/${id}`;

// Contact Dictionary
export const ROUTE_CONTACT_TYPE_LIST = '/contact_type';

// Address Dictionary
export const ROUTE_ADDRESS_TYPE_CREATE = '/address_type/create';
export const ROUTE_ADDRESS_TYPE_LIST = '/address_type';

// Countries Dictionary
export const ROUTE_COUNTRY_LIST = '/countries';

// Consent types
export const ROUTE_CONSENTS = '/consents';
export const ROUTE_CONSENT_EDIT = (id = ':id') => `/consent/edit/${id}`;
export const ROUTE_CONSENT_CREATE = "/consent/create";

// Employee document types.
export const ROUTE_EMPLOYEE_DOCUMENT_TYPE_CREATE = '/employee-document-types/create';
export const ROUTE_EMPLOYEE_DOCUMENT_TYPE_LIST = '/employee-document-types';

// ROUTE
export const ROUTE_ROUTES = "/route";
export const ROUTE_ROUTE_REPORT = "/route-report";
export const ROUTE_TELEMETRY = "/telemetry";
export const ROUTE_POI = "/user_poi";

//Device list
export const ROUTE_DEVICES = "/devices";
export const ROUTE_DEVICES_DETAILS = (id = ":id") => `/devices/${id}`;

//Customer list
export const ROUTE_CUSTOMERS = "/customers";
export const ROUTE_CUSTOMERS_DETAILS = (id = ":id") => `/customers/${id}`;

//Driver list
export const ROUTE_DRIVERS = "/drivers";
export const ROUTE_DRIVERS_DETAILS = (id = ":id") => `/drivers/${id}`;

//Vehicles list
export const ROUTE_VEHICLES = "/vehicles";
export const ROUTE_VEHICLES_DETAILS = (id = ":id") =>  `/vehicles/${id}`;

//Statistics
export const ROUTE_STATISTICS = "/statistics";

//Ecodriving
export const ROUTE_ECODRIVING = "/ecodriving";

//Invoices
export const ROUTE_INVOICE = `/invoices`;
export const ROUTE_INVOICE_AFTER_PAY = (id = ":id") =>  `/summary-pay/${id}`;

export const ROUTE_INVOICES = (id = ":id") =>  `/invoices/${id}`;
export const ROUTE_INVOICES_DETAILS = (id = ":id") =>  `/invoices/details/${id}`;

//Tariff
export const ROUTE_TARIFF_LIST = `/tariffs`;
export const ROUTE_TARIFF_LOGS = `/tariffs-logs`;

//Payment
export const ROUTE_PAYMENT_LOGS = '/payments-logs';

//SENT
export const ROUTE_SENT = '/sent';



